/* ============================================================
   WALL OF FAME — Sneaker Lane
   Carrusel con rotación automática. Vanilla JS, sin dependencias.

   Los datos salen del <script type="application/json" id="wall-datos"> que
   imprime la sección, así el JS es estático y cacheable.

   Comportamiento:
     · cada 3 s cambia UNA tarjeta, elegida al azar
     · no repite: pasan las 40 antes de que vuelva a salir ninguna
     · se para si el ratón está encima del carrusel, si la pestaña no se ve,
       o mientras alguien desliza los artículos de una tarjeta
     · respeta "reducir movimiento" del sistema: si está activo, no rota
   ============================================================ */
(function(){
"use strict";

var origen = document.getElementById("wall-datos");
if (!origen) return;
var POOL = JSON.parse(origen.textContent);
if (!POOL.length) return;

var REDUCED   = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
var HAS_HOVER = window.matchMedia("(hover: hover)").matches;

/* Cuántas tarjetas hay en el carril y cada cuánto cambia una. */
var cfg = { count: 10, ivl: 3000, paused: false };

/* ---------------------------------------------------------- utilidades */
function shuffle(a){
  const r = a.slice();
  for (let i = r.length - 1; i > 0; i--){
    const j = Math.floor(Math.random() * (i + 1));
    [r[i], r[j]] = [r[j], r[i]];
  }
  return r;
}

/* Conjunto inicial: aleatorio sobre todo el pool. */
function pickInitial(n){
  return shuffle(POOL.map((p, i) => i)).slice(0, n);
}

/* ---------------------------------------------------------- instancia */
class Wall {
  constructor(root){
    this.root  = root;
    this.rail  = root.querySelector(".sl__rail");
    this.tpl   = document.getElementById("cardTpl");
    this.hover = -1;
    this.visible = [];
    /* Modo "muro completo" (página Ver todo): pinta TODAS las personas en una
       rejilla, en orden, y NO rota. Se activa con .sl-slot--all en el envoltorio. */
    this.all = !!root.closest(".sl-slot--all");

    this.rail.addEventListener("pointerenter", () => this.railHover = true);
    this.rail.addEventListener("pointerleave", () => { this.railHover = false; this.hover = -1; });

    root.querySelectorAll(".sl__arrow").forEach(btn => {
      btn.addEventListener("click", () => {
        const card = this.rail.querySelector(".sw");
        const step = card ? card.offsetWidth + 16 : 260;
        this.rail.scrollBy({ left: btn.dataset.dir === "next" ? step : -step,
                             behavior: REDUCED ? "auto" : "smooth" });
      });
    });
    this.rail.addEventListener("scroll", () => this.syncArrows(), { passive:true });
  }

  build(n){
    this.busy = false;
    if (this.all){
      this.visible = POOL.map(function(p, i){ return i; });  /* todas, en orden */
    } else {
      this.visible = pickInitial(n);
      this.refillQueue();
    }
    this.rail.textContent = "";
    this.visible.forEach((idx, slot) => {
      const el = this.tpl.content.firstElementChild.cloneNode(true);
      el.dataset.slot = slot;
      el.addEventListener("pointerenter", () => this.hover = slot);

      /* Pulsar la portada revela la foto de tienda. Es el gesto de móvil,
         y en escritorio conserva además el hover. */
      const cover = el.querySelector(".sw__flipbtn");
      cover.addEventListener("click", () => {
        if (!el.classList.contains("sw--proof")) return;
        const on = el.dataset.flip === "1";
        if (on) delete el.dataset.flip; else el.dataset.flip = "1";
        cover.setAttribute("aria-pressed", on ? "false" : "true");
      });
      /* En escritorio el hover ya revela: al salir se deja como estaba. */
      if (HAS_HOVER){
        el.addEventListener("pointerleave", () => {
          delete el.dataset.flip;
          cover.setAttribute("aria-pressed", "false");
        });
      }
      this.rail.appendChild(el);
      this.paint(el, idx);
    });
    this.rail.scrollLeft = 0;
    requestAnimationFrame(() => this.syncArrows());
  }

  paint(el, idx){
    const p = POOL[idx];
    delete el.dataset.flip;
    const cv = el.querySelector(".sw__flipbtn");
    cv.setAttribute("aria-pressed", "false");
    cv.setAttribute("aria-label", "Ver a " + p.nombre + " en la tienda");
    cv.disabled = !p.enTienda;
    el.classList.toggle("sw--proof",   !!p.enTienda);
    el.classList.toggle("sw--noproof", !p.enTienda);
    el.classList.toggle("sw--topmeta", !!p.nombreArriba);

    const portrait = el.querySelector(".sw__portrait");
    portrait.style.backgroundImage = p.portada ? 'url("' + p.portada + '")' : "";
    portrait.setAttribute("aria-label", p.nombre);
    

    if (p.enTienda){
      el.querySelector(".sw__store").style.backgroundImage = 'url("' + p.enTienda + '")';
    }

    el.querySelector(".sw__disc-l").textContent = p.categoria;
    el.querySelector(".sw__disc-s").textContent = p.categoriaCorta || p.categoria;
    el.querySelector(".sw__name").textContent = p.nombre;

    const ig  = el.querySelector(".sw__ig");
    const at  = el.querySelector(".sw__at");
    const chk = el.querySelector(".sw__check");
    if (p.instagram){
      const h = p.instagram.replace(/^@/, "");
      at.textContent = "@" + h;
      ig.href = "https://instagram.com/" + h;
      ig.setAttribute("aria-label", "Instagram de " + p.nombre);
      delete ig.dataset.empty;
      if (p.verificado) chk.removeAttribute("hidden"); else chk.setAttribute("hidden", "");
    } else {
      /* Sin Instagram: no se muestra nada, ni el hueco. */
      at.textContent = "";
      ig.removeAttribute("href");
      ig.removeAttribute("aria-label");
      ig.dataset.empty = "1";
      chk.setAttribute("hidden", "");
    }

    this.buildShop(el, p);
  }

  /* Una franja por artículo. Con más de uno se pasan deslizando y aparecen los
     puntitos; el que no tenga ficha en la web se enseña sin botón. */
  buildShop(el, p){
    const slides = el.querySelector(".sw__slides");
    const dots   = el.querySelector(".sw__dots");
    slides.textContent = "";
    dots.textContent   = "";
    const items = p.articulos || [];
    el.classList.toggle("sw--multi", items.length > 1);

    items.forEach((it, i) => {
      const a = document.createElement("a");
      a.className = "sw__buy";
      if (it.url){
        a.href = it.url;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        a.setAttribute("aria-label", "Ver " + it.titulo + " en la tienda");
      } else {
        a.classList.add("sw__buy--nolink");
      }

      const th = document.createElement("span");
      th.className = "sw__thumb";
      if (it.img) th.style.backgroundImage = 'url("' + it.img + '")';
      else th.dataset.none = "1";

      const prod = document.createElement("span");
      prod.className = "sw__prod";
      const lab = document.createElement("span");
      lab.className = "sw__plabel";
      /* Siempre "Se llevó", sin el contador: el cliente lo quitó. La posición
         dentro del carrusel ya la dicen los puntitos de abajo. */
      lab.textContent = "Se llevó";
      const nm = document.createElement("span");
      nm.className = "sw__pname";
      nm.textContent = it.titulo;
      prod.append(lab, nm);
      /* Sin precio: el cliente lo quitó. Los suyos van por talla, así que el de
         la tarjeta nunca sería el que acaba pagando. Solo se escribe algo aquí
         cuando el artículo no tiene ficha, para explicar por qué no hay botón. */
      if (!it.url){
        const nota = document.createElement("span");
        nota.className = "sw__pnote";
        nota.textContent = "No disponible en la web";
        prod.appendChild(nota);
      }
      a.append(th, prod);

      if (it.url){
        const go = document.createElement("span");
        go.className = "sw__go";
        go.innerHTML = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M5 10h9M10 5.5 14.5 10 10 14.5"/></svg>';
        a.appendChild(go);
      }
      slides.appendChild(a);

      if (items.length > 1){
        const b = document.createElement("button");
        b.type = "button";
        b.setAttribute("aria-label", "Artículo " + (i + 1) + " de " + items.length);
        b.setAttribute("aria-current", i === 0 ? "true" : "false");
        b.addEventListener("click", () => {
          slides.scrollTo({ left: slides.clientWidth * i,
                            behavior: REDUCED ? "auto" : "smooth" });
        });
        dots.appendChild(b);
      }
    });

    slides.scrollLeft = 0;
    /* El listener va en el contenedor, que sobrevive a los repintados. */
    if (!slides.dataset.bound){
      slides.dataset.bound = "1";
      slides.addEventListener("scroll", () => {
        const n = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
        Array.from(dots.children).forEach((d, i) =>
          d.setAttribute("aria-current", i === n ? "true" : "false"));
        /* Mientras alguien pasa artículos, esa tarjeta no rota bajo su dedo. */
        el.dataset.busy = "1";
        clearTimeout(el._t);
        el._t = setTimeout(() => delete el.dataset.busy, 4000);
      }, { passive: true });
    }
  }

  

  /* Cola barajada: entra la siguiente de la cola y la que sale vuelve al final.
     Así pasan TODAS las fotos, sin repetir ninguna antes de tiempo. */
  refillQueue(){
    const hidden = POOL.map((p, i) => i).filter(i => !this.visible.includes(i));
    this.queue = shuffle(hidden);
  }

  findSwap(){
    if (!this.queue || !this.queue.length) this.refillQueue();
    if (!this.queue.length) return null;
    /* Fuera la que tiene el ratón encima y la que alguien está manoseando. */
    const slots = shuffle(this.visible.map((v, s) => s).filter(s =>
      s !== this.hover && !(this.rail.children[s] || {}).dataset?.busy));
    if (!slots.length) return null;
    /* Solo se mira el primero de la cola: se saca al confirmar el cambio, no aquí.
       Si se sacara ahora y el intercambio se solapara, esa foto se perdería. */
    return { inIdx: this.queue[0], slot: slots[0] };
  }

  /* Aplica el cambio y devuelve la que sale al final de la cola. */
  commit(slot, inIdx){
    const saliente = this.visible[slot];
    const pos = this.queue.indexOf(inIdx);
    if (pos !== -1) this.queue.splice(pos, 1);
    this.visible[slot] = inIdx;
    this.queue.push(saliente);
  }

  rotate(force){
    if (!force && (cfg.paused || this.railHover || document.hidden)) return;
    if (this.busy) return;              /* ya hay un intercambio en marcha */
    const s = this.findSwap();
    if (!s) return;
    const el = this.rail.children[s.slot];
    if (!el) return;

    /* Repintar puede desplazar el carril: se guarda y restaura el scroll. */
    const keep = this.rail.scrollLeft;
    if (REDUCED){
      this.commit(s.slot, s.inIdx);
      this.paint(el, s.inIdx);
      this.rail.scrollLeft = keep;
      this.syncArrows();
      return;
    }
    this.busy = true;
    el.dataset.swap = "out";
    setTimeout(() => {
      this.commit(s.slot, s.inIdx);
      this.paint(el, s.inIdx);
      delete el.dataset.swap;
      this.rail.scrollLeft = keep;
      this.syncArrows();
      this.busy = false;
    }, 340);
  }

  syncArrows(){
    const prev = this.root.querySelector('.sl__arrow--prev');
    const next = this.root.querySelector('.sl__arrow--next');
    if (!prev || !next) return;
    const max = this.rail.scrollWidth - this.rail.clientWidth - 2;
    prev.hidden = this.rail.scrollLeft <= 2;
    next.hidden = this.rail.scrollLeft >= max;
  }
}



var walls = Array.prototype.map.call(document.querySelectorAll(".sl"), function(el){
  return new Wall(el);
});
walls.forEach(function(w){ w.build(w.all ? POOL.length : Math.min(cfg.count, POOL.length)); });

if (!REDUCED) {
  setInterval(function(){
    walls.forEach(function(w){ if (!w.all) w.rotate(false); });  /* el muro completo no rota */
  }, cfg.ivl);
}

/* ---- Marquee de @handles (ticker hype bajo el carril) ----
   Dos secuencias idénticas para que el loop a -50% sea sin costura. */
(function buildTicker(){
  var track = document.querySelector("[data-sl-ticker] .sl__ticker-track");
  if (!track) return;
  var handles = POOL.map(function(p){ return p.instagram; }).filter(Boolean);
  if (!handles.length) return;
  function item(h){
    var s = document.createElement("span");
    s.className = "sl__ticker-item";
    s.textContent = "@" + h.replace(/^@/, "");
    return s;
  }
  for (var copy = 0; copy < 2; copy++){
    handles.forEach(function(h){ track.appendChild(item(h)); });
  }
})();
})();
